import React from "react";
import {
  UsergroupAddOutlined,
  FileTextOutlined,
  AuditOutlined,
  IssuesCloseOutlined,
  ExperimentOutlined,
  AimOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
const TAB_ARRAY = [
  {
    label: "User Management",
    icon: <UsergroupAddOutlined className="tab_icon" />,
    url: "/admin/user-management",
  },
  {
    label: "Data Management",
    icon: <AuditOutlined className="tab_icon" />,
    url: "/admin/data-management",
  },
  {
    label: "Status Management",
    icon: <IssuesCloseOutlined className="tab_icon" />,
    url: "/admin/status-management",
  },
  {
    label: "Flight Model Management",
    icon: <AimOutlined className="tab_icon" />,
    url: "/admin/flight-model-management",
  },
  {
    label: "Ranking Algorithm Settings",
    icon: <ExperimentOutlined className="tab_icon" />,
    url: "/admin/ranking-algorithm-settings",
  },
  {
    label: "Logs",
    icon: <FileTextOutlined className="tab_icon" />,
    url: "/admin/logs",
  },
];

function AdminHeaderTab({ currrentTab }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "1px" }}>
        {TAB_ARRAY.map((ele) => (
          <div
            key={ele.label}
            className={`admin_tab_wraper ${currrentTab === ele.label && "active_tab"}`}
            onClick={() => currrentTab !== ele.label && navigate(ele.url)}
          >
            <div className="admin_tab_child">
              {ele.icon}
              <p className="tab_label">{ele.label}</p>
            </div>
          </div>
        ))}
      </div>
      <Button type="link" onClick={() => navigate("/")}>
        Back to Dashboard
      </Button>
    </div>
  );
}

export default AdminHeaderTab;
